import { styled } from 'baseui'

export const Row = styled<'li', { $isLate: boolean }>('li', ({ $theme, $isLate }) => ({
  marginBottom: '0.75rem',
  padding: '0.75rem 1rem',
  borderRadius: $theme.borders.radius300,
  border: `1px solid ${$theme.colors.borderOpaque}`,
  borderLeft: `0.25rem solid ${$isLate ? $theme.colors.warning : $theme.colors.borderOpaque}`,
  backgroundColor: $theme.colors.white,
}))

export const RowHeader = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '0.25rem',
})

export const Time = styled('span', ({ $theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  color: $theme.colors.textHeading,
}))

export const LateBadge = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 600,
  color: $theme.colors.warning,
}))

export const OutcomeBadge = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  color: $theme.colors.textMuted,
}))

export const Customer = styled('p', ({ $theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  fontWeight: 600,
  color: $theme.colors.textHeading,
}))

export const Phone = styled('p', ({ $theme }) => ({
  margin: '0.125rem 0 0.5rem',
  fontSize: '0.875rem',
  color: $theme.colors.textHeading,
}))

export const ContactLink = styled('button', ({ $theme }) => ({
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  color: $theme.colors.primary,
  fontSize: '0.875rem',
  cursor: 'pointer',
  textDecoration: 'underline',
}))
